export const INDUSTRY_TEMPLATES = {
  general: {
    label: 'Everyday business',
    exampleBusiness: 'Sunrise Daily Services',
    productPlaceholder: 'Product name (e.g. Daily essentials box)',
    emptyProducts: 'No products yet. Add any recurring item or service you deliver.',
    customerLinkTitle: 'Link your service provider',
    customerLinkHelp: 'Enter the phone number your provider has on file to see your subscriptions, deliveries and bills.',
    aiExamples: [
      'What should I prepare tomorrow?',
      'Who has pending payments?',
      'Pause deliveries for 15 to 20 July',
      'Change quantity to 2 items from Sunday',
    ],
  },
  milk_vendor: {
    label: 'Milk vendor',
    exampleBusiness: 'Ramesh Milk Dairy',
    productPlaceholder: 'Product name (e.g. Buffalo milk)',
  },
  kirana: {
    label: 'Kirana / General store',
    exampleBusiness: 'Sharma Daily Needs',
    productPlaceholder: 'Product name (e.g. Breakfast kit)',
  },
  water: {
    label: 'Water supplier',
    exampleBusiness: 'FreshDrop Water Supply',
    productPlaceholder: 'Product name (e.g. 20L water can)',
  },
  newspaper: {
    label: 'Newspaper vendor',
    exampleBusiness: 'Morning Press Delivery',
    productPlaceholder: 'Product name (e.g. Daily newspaper)',
  },
  tiffin: {
    label: 'Tiffin service',
    exampleBusiness: 'Homely Tiffin Service',
    productPlaceholder: 'Product name (e.g. Lunch tiffin)',
  },
  laundry: {
    label: 'Laundry',
    exampleBusiness: 'QuickWash Laundry',
    productPlaceholder: 'Product name (e.g. Monthly laundry plan)',
  },
};

export const BUSINESS_TYPES = [
  ['milk_vendor', INDUSTRY_TEMPLATES.milk_vendor.label],
  ['kirana', INDUSTRY_TEMPLATES.kirana.label],
  ['water', INDUSTRY_TEMPLATES.water.label],
  ['newspaper', INDUSTRY_TEMPLATES.newspaper.label],
  ['tiffin', INDUSTRY_TEMPLATES.tiffin.label],
  ['laundry', INDUSTRY_TEMPLATES.laundry.label],
  ['general', INDUSTRY_TEMPLATES.general.label],
];

export function getIndustryTemplate(type) {
  return {
    ...INDUSTRY_TEMPLATES.general,
    ...(INDUSTRY_TEMPLATES[type] || {}),
  };
}
